import { Flex, Heading, Text, useToast } from "@chakra-ui/react";
import { FormProps } from "@rjsf/core";
import { IoMdCheckmark } from "react-icons/io";
import { MdErrorOutline } from "react-icons/md";

import { SchemaForFormData } from "@nens/shared-utils";

import { getApi } from "@/api/api-configuration";
import { BrostarForm } from "@/libs/brostar-form";
import { useUser } from "@/providers/auth-provider";

const getUuidFromUrl = (url: string) => {
  if (url.charAt(url.length - 1) !== "/") url += "/";
  const urlParts = url.split("/");
  return urlParts[urlParts.length - 2];
};

interface BroCredentials {
  broUserToken: string;
  broUserPassword: string;
}

const schema: SchemaForFormData<BroCredentials> = {
  type: "object",
  title: "",
  required: ["broUserToken", "broUserPassword"],
  properties: {
    broUserToken: {
      type: "string",
      title: "BRO Gebruikerstoken",
    },
    broUserPassword: {
      type: "string",
      title: "BRO Wachtwoordtoken",
    },
  },
};

export function BroCredentialsForm() {
  const api = getApi();
  const user = useUser();
  const toast = useToast();

  const onSubmit: FormProps<BroCredentials>["onSubmit"] = async ({ formData }) => {
    if (!formData?.broUserToken || !formData?.broUserPassword) return;
    const uuid = getUuidFromUrl(user.organisationUrl);
    await api.apiOrganisationsPartialUpdate({
      uuid,
      data: {
        name: user.organisation,
        kvkNumber: user.kvk,
        broUserToken: formData.broUserToken,
        broUserPassword: formData.broUserPassword,
      },
    });
    toast({
      title: "Gelukt",
      description: `Token en wachtwoord succesvol aangepast!`,
      status: "success",
      duration: 5000,
      isClosable: true,
    });
  };

  return (
    <Flex flexDir="column" pos="relative">
      <Heading as="h2" pb="3" size="xl">
        BRO gegevens aanpassen
      </Heading>
      <Text maxW="600px">
        Geef hier een token en wachtwoord op om gegevens te kunnen aanleveren via deze applicatie.
        Je kan dit aanmaken via je persoonlijke bronhoudersportaal:
        <a
          style={{ color: "blue", textDecoration: "underline", display: "block" }}
          rel="noreferrer"
          target="_blank"
          href="https://www.bronhouderportaal.nl/mijnorganisatie"
        >
          TNO - Geologische Dienst Nederland
        </a>
      </Text>
      <BrostarForm<BroCredentials>
        schema={schema}
        onSubmit={onSubmit}
        uploadTask={undefined}
        renderButtons={({ submitButtonCustomTitle }) =>
          submitButtonCustomTitle("Wijzigingen opslaan")
        }
      />
      <Flex alignItems="center" mt={4}>
        {user.broCredentialsSet ? (
          <>
            <IoMdCheckmark size={20} />
            <Text pl="1">Je BRO credentials zijn ingesteld</Text>
          </>
        ) : (
          <>
            <MdErrorOutline size={22} />
            <Text pl="1">Je hebt nog geen BRO credentials ingesteld</Text>
          </>
        )}
      </Flex>
    </Flex>
  );
}
